// The maximum size that can be handled by an export to PolyOffice, in bytes
export const POLYOFFICE_MAX_EXPORT_SIZE = 150 * 1024 * 1024
